/** @format */

import React, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";
import "./OldApp.css";
import Header from "./components/old-site/Header.js";
import Footer from "./components/old-site/Footer.js";
import { AnalyticsTracker2 } from "./components/Analytics";
import { Helmet } from "react-helmet";
import { metaDescription } from "./components/Utils";
import HeapAnalytics from "./components/HeapAnalytics";
import {
  PropertyRedirect,
  SearchRedirect,
} from "./components/old-site/OldSiteRedirects";

const API_BASE = "/";
const API_BASE_PROPERTIES = `${API_BASE}properties/`;
const API_BASE_IMAGES = `${API_BASE}images/`;
const API_BASE_API = `${API_BASE}api/`;

class ModalSwitch extends React.Component {
  /*
    Any of this previousLocation nonsense is based on trying to have differen
    navigation on small/mobile.

    Desktop/large:
    Main view has map and cards (left/right)
    Click a card, get a popup for the property.
      Within the card are up to 3 nearby property cards.
      Click these cards, and the URL updates and that property's card is shown instead.
      Closing the popup closes the single popup and takes you back to the search/cards view.
        (If you changed cities by browsing nearby, the map now shows the city of latest property you were looking at, not the first one that created the popup.)

    Mobile/small:
    Main view has map and cards (top/bottom)
    Tap a card, get a full-screen view of the property.
      Within the property are up to 3 nearby property cards.
      Tap these cards, and the navigate to that property's page.
      The Back button takes you back through previous properties.

    Can we make this all really the same:
    - Property -> Property is always a navigation (push)
    - Closing the modal always closes the modal
      - Mobile doesn't have this, but it never did.
    - Back button always goes back to what you were last looking at.



     */
  // TODO 2023-2024 Remove any pages that were replaced in App.js or no longer used after the redesign
  render() {
    return (
      <Switch>
        <Route
            exact
            path="/search/:q/medical-office-space-for-lease/:propertyId"
            render={(props) => (
                <PropertyRedirect {...this.props} {...props} />
            )}
        />
        <Route
          path="/search/:q"
          render={(props) => (
            <SearchRedirect searchQuery={props.match.params.q} />
          )}
        />
      </Switch>
    );
  }
}

class OldApp extends Component {
  constructor() {
    super();
    this.state = {
      backgroundIdxDelta: 0,
      drawBounds: false,
      retrievedProperties: {},
      cookiesAccepted: false,
    };
    this.prevBg = this.prevBg.bind(this);
    this.nextBg = this.nextBg.bind(this);
    this.toggleDrawBounds = this.toggleDrawBounds.bind(this);
    this.getPropertyData = this.getPropertyData.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
  }

  // TODO - remove this function if it is not used in the new site design
  // This was written before React Suspense and could probably be replaced with something better.
  // The old app used this to fetch individual property data like:
  //     const id = match?.params?.propertyId;
  //     const property = getPropertyData(id, { returnPromise: true });
  getPropertyData(
    propertyId,
    { callback, returnPromise = false, append = {} } = {},
  ) {
    // callback is used in StandaloneProperty
    if (!propertyId) return null;
    let alreadyFoundProperty =
      propertyId &&
      this.state.retrievedProperties &&
      this.state.retrievedProperties[propertyId];
    if (alreadyFoundProperty) {
      if (alreadyFoundProperty instanceof Promise) {
        return returnPromise && alreadyFoundProperty; // if !returnPromise, this returns false if we haven't loaded the property yet, which is what most components expect.
      } else return Object.assign({}, alreadyFoundProperty, append);
    } else {
      this.setState((prevState) => {
        let propertyPromise = fetch(`${API_BASE_PROPERTIES}${propertyId}.json`)
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              console.error(`Fetch failed for ${propertyId}.`);
              return {
                ERROR: true,
                wtweb_id: propertyId,
                /*retry: () =>
                                  this.getPropertyData(propertyId, options)*/
              };
            }
          })
          .then((p) =>
            this.setState((prevState) => {
              console.debug(`resolved promise ${propertyId}`);

              return {
                retrievedProperties: Object.assign(
                  {},
                  prevState.retrievedProperties,
                  { [propertyId]: p },
                ),
              };
            }, callback),
          )
          .catch((error) => {
            this.setState((prevState) => {
              return {
                retrievedProperties: Object.assign(
                  {},
                  prevState.retrievedProperties,
                  {
                    [propertyId]: {
                      ERROR: true,
                      wtweb_id: propertyId,
                      /*retry: () =>
                                                  this.getPropertyData(propertyId, options)*/
                    },
                  },
                ),
              };
            }, callback);
          });
        console.debug(`storing promise ${propertyId}`);
        return {
          retrievedProperties: Object.assign(
            {},
            prevState.retrievedProperties,
            { [propertyId]: propertyPromise },
          ),
        };
      });
      return null;
    }
  }

  prevBg() {
    this.setState((prevState) => ({
      backgroundIdxDelta: prevState.backgroundIdxDelta - 1,
    }));
  }
  nextBg() {
    this.setState((prevState) => ({
      backgroundIdxDelta: prevState.backgroundIdxDelta + 1,
    }));
  }
  toggleDrawBounds() {
    this.setState((prevState) => ({
      drawBounds: !prevState.drawBounds,
    }));
  }

  renderFooter(extraProps) {
    return (
      <Footer
        nextBg={this.nextBg}
        prevBg={this.prevBg}
        toggleDrawBounds={this.toggleDrawBounds}
        {...extraProps}
      />
    );
  }

  onCookiesAccept() {
    this.setState({ cookiesAccepted: true });
  }

  render() {
    console.debug(`In OldApp for ${window.location.href}`);
    return (
      <>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <CompatRouter>
            <div className="App">
              <Helmet>
                <title>
                  Welltower Medical Office For Lease - Building Space For Rent
                </title>
                <meta name="description" content={metaDescription()} />
                {/* NewHeader loads talkfurther on new routes, not sure if we need to load here? */}
                <script id="further" type="text/javascript">
                  {`
                    (function () {
                    var a = document.createElement("script");
                    var b = document.getElementsByTagName("script")[0];
                    a.type = "text/javascript";
                    a.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + "js.talkfurther.com/talkfurther_init.min.js";
                    a.async = true;
                    b.parentNode.insertBefore(a, b);
                    })();
                  `}
                </script>
              </Helmet>
              <Header />
              <Route
                render={(props) => (
                  <React.Fragment>
                    <AnalyticsTracker2
                      trackingId={process.env.REACT_APP_GA4_TOKEN}
                      gtmTrackingId={process.env.REACT_APP_GTM_TOKEN}
                      onCookiesAccept={() => {
                        this.onCookiesAccept();
                      }}
                    />
                    <HeapAnalytics
                      heapAppId={process.env.REACT_APP_HEAP_APPID}
                      cookiesAccepted={this.state.cookiesAccepted}
                    />
                    <ModalSwitch
                      backgroundIdxDelta={this.state.backgroundIdxDelta}
                      drawBounds={this.state.drawBounds}
                      getPropertyData={this.getPropertyData}
                      renderFooter={this.renderFooter}
                      {...props}
                    />
                  </React.Fragment>
                )}
              />
            </div>
          </CompatRouter>
        </BrowserRouter>
      </>
    );
  }
}

export {
  OldApp as default,
  API_BASE_API,
  API_BASE_IMAGES,
  API_BASE_PROPERTIES,
};
